import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  FileLayoutMaintenancePageContext,
  FileLayoutMaintenancePageInitialState,
} from ".";

export const FileLayoutMaintenancePageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    FileLayoutMaintenancePageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <FileLayoutMaintenancePageContext.Provider value={context}>
      {children}
    </FileLayoutMaintenancePageContext.Provider>
  );
};
